/* eslint-disable @typescript-eslint/naming-convention */
import { convertToTitleCase } from "@core-ui/utils/String";

/**
 * This takes a user address object and returns a string of the address information.
 * Logic: flat_no + (address_line2 || landmark) + address
 * Entire string is converted to title case
 */
export const getAddressInfo = (userAddress?: any): string => {
    const { flat_no = "", address_line2 = "", address_line_2 = "", landmark = "", address = "" } = userAddress || {};
    let addressInfoStr = "";

    if (flat_no) {
        addressInfoStr += flat_no + ", ";
    }

    if (address_line2 || address_line_2) {
        addressInfoStr += address_line2 ? address_line2 : address_line_2;
        addressInfoStr += ", ";
    } else if (landmark) {
        addressInfoStr += landmark + ", ";
    }

    if (address) {
        addressInfoStr += address;
    }

    return convertToTitleCase(addressInfoStr);
};
